
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("popup");
  const checkbox = document.querySelector(".no-view");

  // Check if popup was previously hidden
  if (localStorage.getItem("hidePopup") === "true") {
    popup.style.display = "none";
  }

  // Listen for checkbox click
  checkbox.addEventListener("change", function() {
    if (this.checked) {
      // Hide popup
      popup.style.display = "none";
      // Store preference in localStorage
      localStorage.setItem("hidePopup", "true");
    }
  });
});
